import CachedStack from '../../../services/engines/CachedStack';

/**
 * Undo-specific stack. Currently a thin extension of CachedStack — kept as
 * its own class so undo-only behaviour (e.g. max stack size, a separate redo
 * stack) has a home later without touching the generic CachedStack.
 */
export default class UmlUndoCache extends CachedStack {
    _name = 'UmlUndoCache';
}
